export default class Header {
    constructor(element) {
        this.bindMethods()

        this.element = element
        this.offset = 0
        this.lastY = 0

        addEventListener('resize', this.handleResize)
        addEventListener('scroll', this.handleScroll, {
            passive: true
        })

        dispatchEvent(new Event('resize'))
    }

    get offset() {
        return this.currentOffset
    }

    set offset(offset) {
        this.currentOffset = offset
        document.documentElement.style.setProperty('--header-o', `${offset}px`)
    }

    bindMethods() {
        this.handleResize = this.handleResize.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
    }

    handleResize() {
        document.documentElement.style.setProperty('--header-h', `${this.element.offsetHeight}px`)

        this.handleScroll()
    }

    handleScroll() {
        requestAnimationFrame(() => {
            this.offset = Math.min(Math.max(0, this.offset + (this.lastY - scrollY)), this.element.offsetHeight)
    
            this.lastY = scrollY
    
            document.documentElement.dataset.scroll = scrollY <= this.element.offsetHeight ? 'start' : (scrollY + innerHeight === document.body.scrollHeight ? 'end' : 'ongoing')
        })
    }
}